@if (vehicle().registrationCertificate; as registrationCertificate) {
  <section>
    <app-modal-documents-heading
      heading="fleet.fleetForm.registrationCertificate.heading"
      [scans]="registrationCertificate.scan"
    ></app-modal-documents-heading>

    <app-modal-date-row
      label="labels.technicalInspectionExpiryDate"
      [expirationDate]="registrationCertificate.technicalInspectionExpiryDate"
      [size]="184"
    ></app-modal-date-row>
  </section>
}

@if (vehicle().co2Emissions; as co2Emissions) {
  <section>
    <app-modal-documents-heading
      heading="fleet.fleetForm.co2Emissions.heading"
      [scans]="co2Emissions.emissionCertificate"
    ></app-modal-documents-heading>

    <onyx-information-row label="labels.emissionStandard">
      {{
        `${DictionaryCode.EMISSION_STANDARD}.${co2Emissions.emissionStandard}`
          | translate
      }}
    </onyx-information-row>
  </section>
}

@if (vehicle().thirdPartyLiabilityInsurance; as thirdPartyLiabilityInsurance) {
  <section>
    <app-modal-documents-heading
      heading="labels.thirdPartyLiabilityInsurance"
      [scans]="thirdPartyLiabilityInsurance.contractScan"
    ></app-modal-documents-heading>

    <onyx-information-list>
      @if (thirdPartyLiabilityInsurance.insuranceNumber; as insuranceNumber) {
        <onyx-information-row label="labels.insuranceNumber">
          {{ insuranceNumber }}
        </onyx-information-row>
      }

      <app-modal-date-row
        label="labels.expirationDate"
        [expirationDate]="thirdPartyLiabilityInsurance.expiryDate"
        [size]="184"
      ></app-modal-date-row>

      <onyx-information-row label="labels.annualCost">
        <app-amount-cell [amount]="thirdPartyLiabilityInsurance.annualCost">
        </app-amount-cell>
      </onyx-information-row>

      @if (thirdPartyLiabilityInsurance.insuranceSum; as insuranceSum) {
        <onyx-information-row label="labels.insuranceSum">
          <app-amount-cell [amount]="insuranceSum"></app-amount-cell>
        </onyx-information-row>
      }
    </onyx-information-list>
  </section>
}

@if (vehicle().comprehensiveInsurance; as comprehensiveInsurance) {
  <section>
    <app-modal-documents-heading
      heading="labels.comprehensiveInsurance"
      [scans]="comprehensiveInsurance.contractScan"
    ></app-modal-documents-heading>

    <onyx-information-list>
      @if (comprehensiveInsurance.insuranceNumber; as insuranceNumber) {
        <onyx-information-row label="labels.insuranceNumber">
          {{ insuranceNumber }}
        </onyx-information-row>
      }

      <app-modal-date-row
        label="labels.expirationDate"
        [expirationDate]="comprehensiveInsurance.expiryDate"
        [size]="184"
      ></app-modal-date-row>

      <onyx-information-row label="labels.annualCost">
        <app-amount-cell [amount]="comprehensiveInsurance.annualCost">
        </app-amount-cell>
      </onyx-information-row>

      @if (comprehensiveInsurance.insuranceSum; as insuranceSum) {
        <onyx-information-row label="labels.insuranceSum">
          <app-amount-cell [amount]="insuranceSum"></app-amount-cell>
        </onyx-information-row>
      }
    </onyx-information-list>
  </section>
}
